import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getClientId } from "@smartsheet/lodestar-utils";
import React, { useState, useEffect } from "react";
export var HiddenInput = function HiddenInput(_ref) {
  var clientId = _ref.clientId,
    hiddenInputName = _ref.hiddenInputName,
    getHiddenInputValue = _ref.getHiddenInputValue,
    selectionType = _ref.selectionType;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    hiddenInputValue = _useState2[0],
    setHiddenInputValue = _useState2[1];
  useEffect(function () {
    if (getHiddenInputValue && selectionType) {
      setHiddenInputValue(getHiddenInputValue(selectionType));
    }
  }, [selectionType, getHiddenInputValue]);
  var shouldRender = hiddenInputName && hiddenInputValue !== undefined;
  return shouldRender ? /*#__PURE__*/React.createElement("input", {
    name: hiddenInputName,
    value: hiddenInputValue,
    hidden: true,
    readOnly: true,
    "data-client-id": getClientId(clientId, "-hidden-input")
  }) || null : null;
};
//# sourceMappingURL=HiddenInput.js.map